
<app-add-invoice-item></app-add-invoice-item>
<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.invoice.posted) {
    <div class="alert alert-danger">You cannot edit this invoice it has been posted.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Invoice was updated successfully</div>
  }
  <div class="sheet">
    <h1 class='header'>Edit Invoice - {{this.invoicingPrefix}}{{ this.invoice.id }}</h1>
    <hr />

    <div class='form-row'>
      <div class="form-group col-md-4">
        <label>Account</label>
        <input class='form-control' type='text' readonly [value]='this.invoice.account.name'/>
      </div>
      <div class="form-group col-md-4">
        <label>Invoice Number</label>
        <input class='form-control' type='text' readonly [value]='this.getPrefix() + this.invoice.id.toString()'/>
      </div>
      <div class="form-group col-md-4">
        <label>Invoice Period</label>
        <input class='form-control' type='text' readonly [value]='this.invoice.invoicePeriod.name'/>
      </div>
      <div class="form-group col-md-4">
        <label>Order ref</label>
        <input class='form-control' type='text' [(ngModel)]='this.invoice.poNumber'/>
      </div>
      <div class="form-group col-md-4">
        <label>Load Ex</label>
        <input class='form-control' type='text' [(ngModel)]='this.invoice.loadEx'/>
      </div>

      <div class="form-group col-md-4">
        <label>Tax Type</label>
        <select class='form-control' (change)='this.invoice.taxTypeId = +$event.target.value; this.invoice.taxType = {id: this.invoice.taxTypeId}'>
          @for (type of this.taxTypes; track type) {
            <option [value]='type.id' [selected]='this.invoice.taxTypeId === type.id'>{{ type.name }}({{type.rate}}%)</option>
          }
        </select>
      </div>
    </div>

    <h2 class='header' style='color:black !important'>Invoice Items</h2>

    <button class='btn btn-secondary' type='button' (click)='this.openModal("addInvoiceItemModal")'>Add item</button>
    @if (this.items.length > 0) {
      <table class="table">
        <thead>
          <th>Date</th>
          <th>Qty</th>
          <th>Price</th>
          <!-- <th>Nominal Code</th> -->
          <th>Description</th>
          <th></th>
        </thead>
        <tbody>
          @for (item of this.items; track item; let i = $index) {
            <tr>
              <td>{{ item.date }}</td>
              <td>
                <input type="number" min='0' name='name' class="form-control" id="inputEmail4" [(ngModel)]='item.qty'>
              </td>
              <td>
                <input type="number" name='name' class="form-control" id="inputEmail4" [(ngModel)]='item.price'>
              </td>
              <!-- <td>
              <input type="text" name='name' class="form-control" id="inputEmail4" [(ngModel)]='item.nominalCode'>
            </td> -->
            <td>
              <textarea class='form-control' [(ngModel)]='item.longDescription'></textarea>
            </td>
            <td>
              <button class='btn btn-danger' type="button" (click)='this.onDeleteClickedForItem(i)'><i class="fas fa-trash"></i></button>
              @if (item.jobId !== -1) {
                <button class='btn btn-warning' type='button' [routerLink]='"/job-signoff/land/view/"+ item.jobId +"/manager"'>View Job {{ item.jobId }}</button>
              }
              @if (this.getCreditNoteForInvoiceItem(item.id)) {
                <button class='btn btn-secondary' (click)='this.createCNPDFFile(getCreditNoteForInvoiceItem(item.id).id)'>View Credit note: CR- {{  getCreditNoteForInvoiceItem(item.id).id}}</button>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  }

  @if (this.creditNotes.length > 0) {
    <h2 class='header' style='color:black !important'>Credit Notes</h2>
    @if (this.creditNotes.length > 0) {
      <table class="table">
        <thead>
          <th>Number</th>
          <th>Date</th>
          <th>Value</th>
          <th>Description</th>
          <th></th>
        </thead>
        <tbody>
          @for (item of this.creditNotes; track item) {
            <tr>
              <td>CN-{{ item.id }}</td>
              <td>{{ item.date }}</td>
              <td>-{{ item.value }}</td>
              <td>{{ item.description }}</td>
              <td><button type='button' class='btn btn-warning' (click)='this.createCNPDFFile(item.id)'>View PDF</button></td>
            </tr>
          }
        </tbody>
      </table>
    }
  }

  @if (!this.invoice.posted) {
    <button type="submit" class="btn btn-success" (click)='save()'>Save</button>
    }&nbsp;
    <button type="button" class="btn btn-danger" routerLink='/invoices'>Cancel</button>
  </div>
</div>
